export const parseFacebookUrl = (text: string, url: string): string => {
    return `https://www.facebook.com/sharer/sharer.php?u=${url}&display=popup&quote=${text}`
}
